var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 32,
    viewBox: "0 0 17 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5902 30.548C16.0869 30.0001 16.1321 29.1428 15.7256 28.5387L15.5902 28.3656L4.37764 16L15.5902 3.63442C16.0869 3.08655 16.1321 2.22922 15.7256 1.62508L15.5902 1.452C15.0934 0.904121 14.316 0.854317 13.7683 1.30258L13.6113 1.452L1.40983 14.9088C0.913066 15.4567 0.867905 16.314 1.27435 16.9181L1.40983 17.0912L13.6113 30.548C14.1578 31.1507 15.0437 31.1507 15.5902 30.548Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.1eee0688373907e94e6e656aed183d5a.svg";
export { ForwardRef as ReactComponent };